import React, { useState } from 'react';
import {
  IRolesWithPermissionsQuery,
  IRolesWithPermissionsQueryVariables,
  IRoleWithPermissionsFieldsFragment,
} from '../../utils/apollo/graphqlSchema';
import BuilderSelectMenu from '../../components/Builder/BuilderSelectMenu';
import { useQuery } from '@apollo/client';
import { GET_ROLES_WITH_PERMISSIONS } from '../../utils/apollo/permission';

interface IProps {
  onSelectStartingRole: (
    role: IRoleWithPermissionsFieldsFragment | null,
  ) => void;
}

const emptyPermissionRole = {
  text: 'Empty',
  value: 'EmptyRoleKeyUse',
};

/**
 * PermissionRoleSelector is a component to render a list of roles for user to select as starting role to work on
 */
const PermissionRoleSelector = ({ onSelectStartingRole }: IProps) => {
  const [selectedRoleKey, setSelectedRoleKey] = useState<string>(
    emptyPermissionRole.value,
  );
  const [roles, setRoles] = useState<IRoleWithPermissionsFieldsFragment[]>([]);
  const onFetchRoles = (data: IRolesWithPermissionsQuery) => {
    if (data.roles.entities.length > 0) {
      setRoles(data.roles.entities);
    }
  };
  const { loading } = useQuery<
    IRolesWithPermissionsQuery,
    IRolesWithPermissionsQueryVariables
  >(GET_ROLES_WITH_PERMISSIONS, {
    variables: {
      term: '',
      includeDisabled: false,
      includes: [],
      pagination: { first: 0, after: 0 },
    },
    onCompleted: onFetchRoles,
  });

  const onChange = (roleId: string | null) => {
    if (roleId) {
      setSelectedRoleKey(roleId);
      const selectedRole = roles.find((role) => role.id === roleId);
      if (selectedRole) {
        onSelectStartingRole(selectedRole);
      } else {
        onSelectStartingRole(null);
      }
    }
    return;
  };

  const options = [
    emptyPermissionRole,
    ...roles.map(({ name, id }) => ({ text: name, value: id })),
  ];

  return (
    <BuilderSelectMenu
      options={options}
      onChange={onChange}
      value={selectedRoleKey}
      disabled={loading}
    />
  );
};

export default PermissionRoleSelector;
